<template>
  <external-anchor href="https://discord.com/api/oauth2/authorize?client_id=899026320623804486&permissions=1&scope=bot">
    <slot /></external-anchor>
</template>
